import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const Overlay = styled.div`
  display: flex;
  position: fixed;
  /* align-items: center; */
  /* justify-content: center; */
  top: 0px;
  left: 0px;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  overflow-y: scroll;
  z-index: 101;

  div:nth-child(3) {
    margin: 0 auto;
  }
`;

export const Modal = styled.div`
  position: relative;
  top: 5%;
  /*  top: 50%; */
  /*  left: 50%; */
  /*  transform: translate(-50%, -50%); */

  background-color: ${themeGet('colors.white')};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 18px;
  border-radius: 10px;
  overflow: scroll;

  .close-btn {
    align-self: flex-end;
  }

  h2 {
    font-size: 18px;
    padding-bottom: 10px;
  }

  ul {
    margin: 0;
  }

  li {
    list-style-image: url(data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7);
    line-height: 0;
  }

  div.input {
    margin-bottom: 5px;
  }

  input,
  select {
    font-size: 16px;
    width: 330px;
    border-radius: 5px;
    border-width: 1px;
    border-style: solid;
    border-color: rgb(201, 208, 214);
    border-image: initial;
    padding: 5px 10px;
  }

  input.error {
    border-width: 1px;
    border-style: solid;
    border-color: rgb(216, 52, 77);
    border-image: initial;
  }

  select {
    text-rendering: auto;
    letter-spacing: normal;
    word-spacing: normal;
    text-transform: none;
    text-indent: 0px;
    text-shadow: none;
    display: inline-block;
    text-align: start;
    box-sizing: border-box;
    align-items: center;
    white-space: pre;
    background-color: rgb(248, 248, 248);
    cursor: default;
    margin: 0em;
    font: 400 11px system-ui;
    border-radius: 5px;
    border-width: 1px;
    border-style: solid;
    border-color: rgb(166, 166, 166);
    border-image: initial;
  }

  .hs-form label {
    text-transform: uppercase;
    font-size: 12px;
    color: rgb(50, 60, 71);
    font-weight: 600;
    padding-top: 10px;
    display: inline-block;
  }

  .hs-form span {
    padding-top: 10px;
    line-height: 0;
    text-transform: uppercase;
    font-size: 12px;
    color: rgb(50, 60, 71);
    font-weight: 600;
    display: inline-block;
  }

  .hs_error_rollup .hs-error-msgs label {
    display: flex;
    color: rgb(216, 52, 77);
    margin-top: 10px;
    align-items: center;
    justify-content: space-between;
    background: rgb(253, 239, 239);
    padding: 10px 15px;
  }

  .hs-error-msgs label {
    text-transform: none;
    padding-top: 0px;
    padding-bottom: 10px;
    width: 330px;
    line-height: 1;
  }

  div.actions {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
  }

  input[type='submit'] {
    cursor: pointer;
    color: rgb(255, 255, 255);
    text-transform: uppercase;
    font-weight: 500;
    font-size: 15px;
    margin-top: 10px;
    width: auto;
    background: rgb(77, 154, 255);
    padding: 10px 20px;
    border-radius: 5px;
    font-family: ${themeGet('fonts.primary')};
  }
`;

export const CloseIcon = styled(FontAwesomeIcon)`
  height: 16px;
  width: 10px;
`;
